var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcKids({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-kids",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39701",
    "data-name": "Path 39701",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39703",
    "data-name": "Path 39703",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "child_care_FILL0_wght600_GRAD0_opsz48",
    d: "M22.736,18.345a1.744,1.744,0,0,1-1.751-1.751,1.732,1.732,0,0,1,.511-1.277,1.751,1.751,0,0,1,2.991,1.24,1.732,1.732,0,0,1-.511,1.277A1.688,1.688,0,0,1,22.736,18.345Zm-7.624,0a1.744,1.744,0,0,1-1.751-1.751,1.732,1.732,0,0,1,.511-1.277,1.751,1.751,0,0,1,2.991,1.24,1.732,1.732,0,0,1-.511,1.277A1.688,1.688,0,0,1,15.112,18.345ZM18.942,26a6.892,6.892,0,0,1-3.848-1.131,7.09,7.09,0,0,1-2.608-3.028H25.4a7.09,7.09,0,0,1-2.608,3.028A6.892,6.892,0,0,1,18.942,26Zm0,6.566a13.145,13.145,0,0,1-5.289-1.076,13.828,13.828,0,0,1-7.277-7.277,13.537,13.537,0,0,1,0-10.578A13.9,13.9,0,0,1,9.312,9.3a14.158,14.158,0,0,1,4.341-2.955A12.957,12.957,0,0,1,18.942,5.25a13.145,13.145,0,0,1,5.289,1.076,13.962,13.962,0,0,1,7.313,7.313,13.145,13.145,0,0,1,1.076,5.289,12.957,12.957,0,0,1-1.094,5.289,14.158,14.158,0,0,1-2.955,4.341,13.9,13.9,0,0,1-4.341,2.936A13.145,13.145,0,0,1,18.942,32.571Zm0-2.882a10.414,10.414,0,0,0,7.587-3.137A10.234,10.234,0,0,0,29.7,19a10.878,10.878,0,0,0-3.119-7.715,10.188,10.188,0,0,0-7.715-3.3q-.365,0-.584.018t-.62.018q-.036.328-.091.73a5.232,5.232,0,0,0-.055.693,1.867,1.867,0,0,0,.529,1.35,1.818,1.818,0,0,0,1.368.547,4.057,4.057,0,0,0,.73-.055,2.977,2.977,0,0,1,.547-.055,1.258,1.258,0,0,1,.73.2.682.682,0,0,1,.292.6,1.078,1.078,0,0,1-.529.912,3.227,3.227,0,0,1-1.769.365A3.724,3.724,0,0,1,16.644,12.2,3.773,3.773,0,0,1,15.55,9.445a4.449,4.449,0,0,1,.036-.492A1.991,1.991,0,0,1,15.7,8.46a11.74,11.74,0,0,0-5.4,3.976,10.289,10.289,0,0,0-2.116,6.42,10.474,10.474,0,0,0,3.173,7.624A10.3,10.3,0,0,0,18.942,29.689ZM18.942,18.856Z",
    transform: "translate(7.088 7.14)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKids);
export default __webpack_public_path__ + "static/media/ic-kids.6652c60feb245f9756c82e5eefbcf170.svg";
export { ForwardRef as ReactComponent };